<template>
  <div>
    <div v-if="loading"> <Loading/> </div>
    <div v-if="!loading">
    <v-toolbar elevation="0">
      <v-toolbar-title class="primary--text">
        <h2>Bookings</h2>
      </v-toolbar-title>
    </v-toolbar>
    <div>
      <v-container>
        <v-tabs v-model="tab">
          <v-tabs-slider color="black"></v-tabs-slider>
          <v-tab>
            <v-badge
            :content="availableBookings.length"
            color="primary--text"
            >
              Available
            </v-badge>
          </v-tab>
          <v-tab>
            <v-badge
            :content="deliverBookings.length"
            color="primary--text"
            >
              Deliveries
            </v-badge>
          </v-tab>
          <v-tab>
            <v-badge
            :content="exchangeBookings.length"
            color="primary--text"
            >
              Exchanges
            </v-badge>
          </v-tab>
          <v-tab>
            <v-badge
            :content="collectBookings.length"
            color="primary--text"
            >
              Collections
            </v-badge>
          </v-tab>
          <v-tab>
            <v-badge
            :content="truckBookings.length"
            color="primary--text"
            >
              Truck
            </v-badge>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <DriverTabs v-bind:bookings="availableBookings" />
          </v-tab-item>
          <v-tab-item>
            <DriverTabs v-bind:bookings="deliverBookings" />
          </v-tab-item>
          <v-tab-item>
            <DriverTabs v-bind:bookings="exchangeBookings" />
          </v-tab-item>
          <v-tab-item>
            <DriverTabs v-bind:bookings="collectBookings" />
          </v-tab-item>
          <v-tab-item>
            <DriverTabs v-bind:bookings="truckBookings" />
          </v-tab-item>
        </v-tabs-items>

      </v-container>
    </div>
    </div>
  </div>
</template>

<script>

import DriverTabs from '@/components/drivers/dashboard/DriverTabs';
import Loading from '@/components/Loading';

export default {
  name: 'Bookings',
  components: {
    DriverTabs,
    Loading
  },
  data() {
    return {
      show: true,
      title: '',
      subTitle: '',
      tab: ''
    }
  },
  computed: {
    user(){
      return this.$store.getters['auth/getUser'];
    },
    loading() {
      return this.$store.getters.getLoading;
    },
    bookingError() {
      return this.$store.getters.getBookingError;
    },
    bookings() {
      return this.$store.getters.getDriverBookings;
    },
    availableBookings() {
      return this.$store.getters.getAvailableBookings;
    },
    collectBookings() {
      return this.$store.getters.getCollectBookings;
    },
    exchangeBookings() {
      return this.$store.getters.getExchangeBookings;
    },
    deliverBookings() {
      return this.$store.getters.getDeliveryBookings;
    },
    truckBookings() {
      return this.$store.getters.getTruckBookings;
    }
  },
  watch: {
    bookingError(error) {
      if (error) {
        console.log(error.message);
      }
    },
    methods: {
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>

</style>